<!--
	@name common-dialog-video
	@description Display an on air article by ID
	@date 2020/03/04
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name">
		<template #header>
			{{ displayItem.title }}
		</template>

		<template #body>
			<h2 v-if="displayItem.title" class="mb-2 text-h5 font-weight-bold">
				{{ displayItem.title }}
			</h2>

			<div v-if="displayItem.abstract" class="text-body-1 font-weight-medium" v-html="$sanitize(displayItem.abstract)" />

			<div v-if="displayItem.vimeo" class="d-block mt-5" style="padding:56.25% 0 0 0;position:relative;">
				<iframe :src="displayItem.vimeo.src" frameborder="0" allow="autoplay;fullscreen; picture-in-picture; clipboard-write; encrypted-media" style="position:absolute;top:0;left:0;width:100%;height:100%;" :title="displayItem.vimeo.title" />
			</div>

			<div v-if="displayItem.iframe" class="px-4 py-2">
				<div style="padding:56.25% 0 0 0;position:relative;">
					<iframe
						:src="displayItem.iframe"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
						style="position:absolute;top:0;left:0;width:100%;height:100%;"
						:title="displayItem.title || null"
					/>
				</div>
			</div>

			<video v-else-if="displayItem.video" class="d-block mt-5" :src="displayItem.video" controls width="100%" />

			<v-img
				v-else-if="displayItem.image"
				:src="displayItem.image | urlize"
				class="align-end mt-5"
				gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
				height="200px"
				cover
			/>

			<div v-if="displayItem.description" class="text-body-1 mt-5" v-html="$sanitize(displayItem.description)" />
		</template>
	</common-dialog>
</template>

<script>
	import CommonDialog from '@/component/common/dialog';
	import { EventBus } from '@/utils';

	export default {
		name: 'common-dialog-video',

        components: {
			CommonDialog
		},

		data() {
			return {
				loading: false,
                displayItem: {}
            };
        },

        computed: {},

		created() {
			EventBus.$on('common-dialog-closed', this.close);
		},

		destroyed() {
			EventBus.$off('common-dialog-closed', this.close);
		},

		methods: {
            /**
			 * @name init
			 * @description init component
			 */
			init(payload) {
				this.setDisplayItem(payload);
				this.$refs.dialog.open();
			},

			/**
			 * @name close
			 * @description Close dialog
			 */
			close() {
				this.setDisplayItem();
				this.$refs.dialog.close();
			},

			setDisplayItem(payload = false) {
				this.displayItem = payload || {
                    title: null,
                    abstract: null,
                    video: null,
                    iframe: null,
                    description: null
                };
			},

            /**
			 * @name openChat
			 */
			openChat() {
				EventBus.$emit('open-chat');
			}
		}
	};
</script>
